import { useEffect, useState } from "react";
import { getMe } from "../../services/api";

type Profile = { fullName: string; email: string; department: string | null };

/** Read-only profile view — shared by the Employee and Manager Settings pages (a Manager is just
 * a Member with `isManager = true`, and `GET /me` already returns the same shape for both, so
 * there's nothing role-specific to branch on here). */
export function EmployeeSettingsPage() {
  const [profile, setProfile] = useState<Profile | "loading">("loading");

  useEffect(() => {
    getMe().then(setProfile);
  }, []);

  if (profile === "loading") return <div className="p-6 text-body">Loading…</div>;

  return (
    <div className="mx-auto max-w-md p-6">
      <h1 className="mb-6 font-sans text-xl text-ink">Settings</h1>
      <dl className="flex flex-col gap-4">
        <div>
          <dt className="text-sm text-body">Name</dt>
          <dd className="text-ink">{profile.fullName}</dd>
        </div>
        <div>
          <dt className="text-sm text-body">Email</dt>
          <dd className="text-ink">{profile.email}</dd>
        </div>
        <div>
          <dt className="text-sm text-body">Department</dt>
          <dd className="text-ink">{profile.department ?? "Unassigned"}</dd>
        </div>
      </dl>
      <p className="mt-6 text-sm text-body">
        To change your password, contact your onboarding contact.
      </p>
    </div>
  );
}
